import React from 'react';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import './App.css';
import { Element } from 'react-scroll';

function App() {

  // Function to handle button click
  const handleButtonClick = () => {
    window.open('https://calendly.com/gabrielbaki/30min', '_blank');
  };

  return (
    <div className="App">
      <Header />
      <Element name="Home" className="home-section">
        <h2>We Guarantee</h2>
        <h2>Protein Crystallization</h2>
        <p>BonzAI offers access to over 100,000 crystallization screening</p> 
        <p>condition predictions and its kits to accelerate scientific discovery</p>
        <button onClick={handleButtonClick}>
          Try BonzAI Now
        </button>
      </Element>

      <Element name="About" className="about-section">
        <h2>About Us</h2>
        <p>Protein crystallization for X-ray crystallography is a bottleneck in drug discovery. Traditional methods are resource-heavy and take months to years.
        We offer ready to use screening kits, online generated recipes for lab customization, and protein structure analysis software tools to accelerate research and discovery in the field of biochemistry.</p>
        <p>Founded by experts in the intersection of machine learning, molecular biology, and robotic lab automation. 
          We're committed to providing precise, fast, and reliable protein crystallization success to support researchers and institutions around the globe.</p>
      </Element>

      <Element name="Pricing" className="pricing-section">
        <h2>Pricing Plans</h2>
        <div className="pricing-tables">
          <div className="pricing-card">
            <h3>Trial Session</h3>
            <p>Take BonzAI for a test drive</p>
            <p><strong>2 months free</strong> full access to web app</p>
            <p><strong>$160/kit</strong> initial 96-well screen</p>
            <p><strong>$80/kit</strong> follow up 96-well screen</p>
            <button onClick={handleButtonClick}>Get Started</button>
          </div>
          <div className="pricing-card">
            <h3>Basic Plan</h3>
            <p>Get up and running quickly</p>
            <p><strong>$400/mo</strong> full access to web app</p>
            <p><strong>$80/kit</strong> initial 96-well screen</p>
            <p><strong>$40/kit</strong> follow up 96-well screen</p>
            <button onClick={handleButtonClick}>Get Started</button>
          </div>
          <div className="pricing-card">
            <h3>Premium Plan</h3>
            <p>For larger drug discovery groups.</p>
            <p><strong>Custom pricing</strong> and features for web</p>
            <p><strong>Custom screening</strong> solution plans</p>
            <p><strong>On premise</strong> infra and support</p>
            <button onClick={handleButtonClick}>Contact Sales</button>
          </div>
        </div>
      </Element>

      <Element name="Contact" className="contact-section">
        <h2>Contact Us</h2>
        <form className="contact-form">
          <div className="input-row">
            <input type="text" placeholder="First name" id="first-name" />
            <input type="text" placeholder="Last name" id="last-name" />
          </div>
          <div className="input-row">
            <input type="email" placeholder="Email" id="email" />
            <input type="tel" placeholder="Phone number" id="phone-number" />
          </div>
          <textarea placeholder="Type your message..." id="message"></textarea>
          <button type="button" onClick={handleButtonClick}>Submit</button>
        </form>
      </Element>

      <Footer />
    </div>
  );
}

export default App;
